import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/strucuture/SubParticelleData.json";
import { fetchCertificazioni, fetchCultura, fetchParticelle, fetchVarieta } from "../../../features/particelle/particelleThunk";
import { selectError, selectIsLoading } from "../../../features/particelle/particelleSlice";
import { selectProdotti } from "../../../features/Prodotti/prodottiSlice";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubParticelle = () => {
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const columns = [
        { field: "particle_id", headerName: "ID Parcella", width: 150 },
        { field: "terreni_id", headerName: "ID Terreno", width: 150 },
        { field: "codice_catastale", headerName: "Cod. Catastale", width: 180 },
        { field: "foglio_catastale", headerName: "Foglio catastale", width: 180 },
        { field: "superficie", headerName: "Sup. (Ha)", width: 150 },
        { field: "coltura", headerName: "Coltura", width: 150 },
        { field: "varieta", headerName: "Varietà", width: 150 },
        { field: "densita", headerName: "Densità", width: 150 },
        { field: "anno", headerName: "Anno imp.", width: 150 },
        { field: "certificazioni", headerName: "Certificazioni", width: 180 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];

    const dispatch = useDispatch();

    const particelleData = useSelector((store) => store?.particelle?.particelle);
    const isLoading = useSelector(selectIsLoading);
    const error = useSelector(selectError);

    useEffect(() => {
        dispatch(fetchCompanies())
      },[])

    useEffect(() => {
        dispatch(fetchParticelle());
        dispatch(fetchCultura())
        dispatch(fetchVarieta())
        dispatch(fetchCertificazioni())
    }, [dispatch, particelleData.length, selectSelectedCompany]);

    return (
        <>
            <div className="pageTemplate">
                {isLoading && <p>Loading...</p>}
                {error && <p style={{ color: "red" }}>Error: {error}</p>}
                <Table data={particelleData} columns={columns} navData={"subParticelle"} deleteFunctions={"deleteParticelleByID"} />
            </div>
        </>
    );
};

export default SubParticelle;
